import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteNotification } from '../../services/NotificationsService';
import { Notification, NotificationDeleteRequest } from '../../types/Notifications';

type Result = UseMutationResult<Notification, Error, NotificationDeleteRequest>;

function useDeleteNotification(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteNotification, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteNotification;
